module.exports = "/img/item-3.c916b455.png";